import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballHitter = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.37744 5.37988H10.7684L9.8411 10.6347H8.45013L8.81333 8.58686H6.97415L6.61095 10.6347H5.21997L6.14729 5.37988H7.53826L7.19052 7.35043H9.0297L9.37744 5.37988Z"
      fill="white"
    />
  </svg>
);
